import axios from 'axios'
import { API_HOST } from 'consts'

export const allowedToCreateApplication = async (collectionId: number) => {
  const response = await axios.get(
    `${API_HOST}/v1/collections/${collectionId}/allowed_to_create_application`
  )
  return response.data.allowedToCreateApplication
}
